import { Signal } from "@angular/core";
import { StorePen } from "../../storage/data-store/model/master-data/store-pen";
import { StoreTrial } from "../../storage/data-store/model/master-data/store-trial";
import { getByIds } from "../record.function";

export function getPensForSectionAndTrial(sectionId: string, trial: StoreTrial, pens: Signal<Record<string, StorePen>>): StorePen[] {
  const pensForTrial = getByIds(pens, trial.penIds);
  const pensForSection = pensForTrial.filter((pen) => {
    return pen.sectionId === sectionId.toString();
  });

  return pensForSection;
}
